module.exports = __webpack_public_path__ + "img/loading_qiu.261d4bb9.png";